import React from "react";
import "./VisionMission.css";
import VisionIcon from "../../assets/vision-icon.png";
import MissionIcon from "../../assets/mission-icon.png";

export default function VisionMission() {
  return (
    <section className="vm-wrapper">
      <div className="vm-container">

        {/* VISION SECTION */}
        <div className="vm-block vm-vision-block">
          <div className="vm-icon-wrap">
            <img src={VisionIcon} alt="Vision Icon" className="vm-icon" />
          </div>

          <div className="vm-content">
            <h2 className="vm-title">Vision</h2>
            <div className="vm-divider"></div>

            <p className="vm-text">
              To be the most trusted and leading developer in the Indian renewable energy
              landscape, recognized for our extreme level of service and our commitment to
              delivering best-in-class, end-to-end Wind and Solar power solutions.
            </p>

            <p className="vm-text">
              We envision a future where we are instrumental in accelerating India's transition
              to sustainable energy, setting new benchmarks for efficiency, reliability, and
              project execution across the green power sector.
            </p>
          </div>
        </div>

        {/* MISSION SECTION */}
        <div className="vm-block vm-mission-block">
          <div className="vm-content">
            <h2 className="vm-title">Mission</h2>
            <div className="vm-divider"></div>

            <p className="vm-text">
              To empower businesses and communities by providing comprehensive, high-quality
              end-to-end solutions for Wind and Solar energy projects. We achieve this by:
            </p>

            <ul className="vm-list">
              <li>
                1. Delivering Excellence: Upholding an extreme level of service in every project
                phase, from conception and development to commissioning and maintenance.
              </li>
              <li>
                2. Driving Sustainability: Actively contributing to the growth of India’s renewable
                energy capacity and promoting environmental stewardship.
              </li>
              <li>
                3. Ensuring Reliability: Utilizing the expertise and stability of the Speed Team
                Group of Companies to execute projects with efficiency, safety, and unwavering
                reliability.
              </li>
            </ul>
          </div>

          <div className="vm-icon-wrap">
            <img src={MissionIcon} alt="Mission Icon" className="vm-icon" />
          </div>
        </div>

      </div>
    </section>
  );
}
